"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24LocationPinDisabledLine = function Svg24LocationPinDisabledLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.17 19.29l-1.429-1.427c-.154.206-.304.401-.446.583C12.546 19.404 12 20 12 20s-.546-.596-1.295-1.554c-1.41-1.805-3.54-4.895-4.078-7.698L4.545 8.666a7.57 7.57 0 0 0-.045.826c0 1.506.452 3.01 1.023 4.335.579 1.343 1.334 2.625 2.063 3.719a35.704 35.704 0 0 0 2.861 3.719l.055.06.016.018.005.005.003.003a2 2 0 0 0 2.948 0l.003-.003.005-.005.016-.018.055-.06.192-.219a36.693 36.693 0 0 0 1.424-1.755zM19.5 9.492C19.5 5.352 16.14 2 12 2a7.49 7.49 0 0 0-5.82 2.766L2.707 1.293a1 1 0 0 0-1.414 1.414l.5.5L5.11 6.525l1.569 1.57 1.848 1.847 3.03 3.03 3.3 3.3 1.443 1.443 4.492 4.492.5.5a1 1 0 0 0 1.414-1.414l-5.317-5.317c.394-.683.767-1.407 1.087-2.149.571-1.324 1.023-2.829 1.023-4.335zm-2 0A5.496 5.496 0 0 0 12 4c-1.796 0-3.392.86-4.395 2.19l1.437 1.438a3.5 3.5 0 1 1 4.83 4.83l2.049 2.049c.89-1.637 1.579-3.42 1.579-5.015zm-4 .008a1.5 1.5 0 0 0-2.954-.369l1.823 1.823A1.5 1.5 0 0 0 13.5 9.5z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24LocationPinDisabledLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24LocationPinDisabledLine;
exports.default = _default;